<template>
  <div class="container">
    <div class="container page_banner ">
      <div class='page_width'>
         <div class="banner_gruop_full" >
            <div class="banner_title"> <span class="color3"></span> Boost Your SaaS Business with Minglepay’s Payment Gateway</div>
            <div class="banner_tips mt-40 fw-300">Supercharge your Software-as-a-Service (SaaS) platform with Minglepay’s seamless payment solutions. Focus on delighting your clients while we handle fast, secure, and scalable transactions to drive your growth.</div>
         </div>
       </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
          <div class="page_title">
            <div class="title_name color2">Let’s Talk Business</div>
            <div class="title_tag color6">Whether you’re a merchant, developer, or partner, our team is ready to assist. Reach out to discuss tailored payment solutions, integrations, or support.</div>
          </div>
          <div class="cate_container">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb42.png" alt="" class="">
                        </div>
                        <div class="half_title color2">For Businesses</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Discover how Minglepay’s payment tools can boost efficiency and growth.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9">
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb43.png" alt="" class="">
                        </div>
                        <div class="half_title color2">For Developers</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Get support for seamless API integration and technical queries.</div>
                    </div>
                </div>
                <div class="grid_md_4 grid_xs_12 grid_sm_12">
                    <div class="tab_left text-l border-primary p-20 h-100p bg_9" >
                        <div class="half_icon w-48px h-48px mb-10">
                          <img src="../../assets/image/tb44.png" alt="" class="">
                        </div>
                        <div class="half_title color2">For Partners</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Explore collaboration opportunities to expand your reach.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">How to Reach Us</div>
                <div class="title_tag color6">We make connecting with us simple and straightforward. Choose the method that works best for you:</div>
            </div>
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t57.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_start" >
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="half_title color2 flex_center_start"><img src="../../assets/image/tb45.png" alt="" class="w-40px h-40px mr-18">Email</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Drop us a message at business@Minglepay.net for prompt assistance.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="half_title color2 flex_center_start"><img src="../../assets/image/tb46.png" alt="" class="w-40px h-40px mr-18">Phone</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Call our team at +86-18681451521 (Mon-Fri, 9 AM - 5 PM GMT).</div>
                    </div>
                    <!-- <div class="tab_left text-l p-20 h-100p  " >
                       <div class="half_title color2 flex_center_start"><img src="../../assets/image/tb47.png" alt="" class="w-40px h-40px mr-18">Live Chat</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300"> Start a real-time conversation via our website for instant support.</div>
                    </div> -->
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg-6 page_top">
        <div class="page_width">
            <div class="page_title py-80">
                <div class="title_name color1 ">Visit Us</div>
                <div class="title_tag color8 flex_center fs-18"><img src="../../assets/image/tb48.png" alt="" class="w-30px h-30px mr-10 " >Room 1208-1209, Shenzhen Center Business Building
West Mintian Road, Futian Central District
Futian District, Shenzhen, China</div>
            </div>
        </div>
    </div>
    <div class="container"> 
      <div class="page_top" >
        <div class="page_width" >
            <div class="page_title pb-30">
                <div class="title_name color2 ">Stay Connected</div>
                <div class="title_tag color6">Join our community and stay updated on the latest in payment innovation.</div>
            </div>
          <div class="py-20">
              <div class="grid grid_md_gap grid_xs_gap" >
                <div class="grid_md_5 grid_xs_12 grid_sm_12 flex_col_start" >
                    <div class="tab_left text-l p-20 h-100p " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Newsletter</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Subscribe for tips, updates, and industry insights.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Social Media</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Follow us on X, LinkedIn, and Instagram for news and updates.</div>
                    </div>
                    <div class="tab_left text-l p-20 h-100p  " >
                        <div class="h-10px mb-20 bg_3 title_line"></div>
                        <div class="half_title color2">Blog</div>
                        <div class="half_text color6 mt-10 fs-14 fw-300">Explore our resources for the latest trends in fintech.</div>
                    </div>
                </div>
                <div class="grid_md_7 grid_xs_12 grid_sm_12 flex_center ">
                  <div class="w-100p">
                    <img src="../../assets/image/t58.png" alt="">
                  </div>
                </div>
              </div>
          </div>
           <div class="pt-20 pb-80">
              <div class="grid grid_md_gap grid_xs_gap">
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                  <div class="w-100p">
                    <img src="../../assets/image/t59.png" alt="">
                  </div>
                </div>
                <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_center">
                    <div class="page_title ">
                        <div class="title_name color2 text-l">Tools to Transform Your SaaS Business</div>
                        <div class="title_tag color6 text-l">Experience the power of instant transactions, actionable analytics, and secure payment processing. With Minglepay, your SaaS platform can focus on innovation and growth while we take care of the payments.</div>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
   
  
    
    

  
  </div>
</template>

<script>


export default {
    data(){
        return{

        }
    }
}
</script>

<style lang="scss" scoped>
.page_banner{
    background-image:url( ../../../public/bg/db_bg11.png);
}
.bg-6{
    background-image:url( ../../../public/bg/bg6.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.title_line{
    width: 120px;
    position: relative;
    &::before{
        content:'';
        width: 20px;
        background:$theme_color3;
        position: absolute;
        right: -38px;
        height: 10px;
    }
}
.half_title{
   font-size: 30px;
}
.half_text{
   font-size: 18px;
}
</style>